import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/presentation.svg'


_pushScopeId("data-v-fb65f58e")
const _hoisted_1 = { class: "presentation" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "presentation",
  src: _imports_0,
  alt: "Apresentação"
}, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialNetworks = _resolveComponent("SocialNetworks")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SocialNetworks),
    _hoisted_2
  ]))
}